import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { switchMap } from 'rxjs';
import { EditableGalleryUrlFieldComponent } from '../../../account/components/editable-gallery-url-field/editable-gallery-url-field.component';
import { isPicflowIOSApp } from '../../../lib/is-ios-app';
import { GalleryService } from '../../../services/gallery.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { GalleryPublicViewOnlyAccessItemComponent } from '../gallery-public-view-only-access-item/gallery-public-view-only-access-item.component';
import { GalleryPublicVisibilityAccessItemComponent } from '../gallery-public-visibility-access-item/gallery-public-visibility-access-item.component';
import { PublicPasswordItemComponent } from '../public-password-item/public-password-item.component';
import { PublicRequireIdentificationItemComponent } from '../public-require-identification-item/public-require-identification-item.component';

@Component({
  selector: 'app-share-gallery-link',
  imports: [
    ButtonDirective,
    SvgComponent,
    EditableGalleryUrlFieldComponent,
    PublicPasswordItemComponent,
    PublicRequireIdentificationItemComponent,
    GalleryPublicVisibilityAccessItemComponent,
    GalleryPublicViewOnlyAccessItemComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './share-gallery-link.component.html',
  styleUrl: './share-gallery-link.component.scss',
})
export class ShareGalleryLinkComponent {
  private galleryService = inject(GalleryService);
  gallery = input.required<GalleryDto>();
  onBack = output<void>();
  isEditingPath = signal(false);

  public galleryPermissions = toSignal(
    toObservable(this.gallery).pipe(switchMap(gallery => this.galleryService.getGalleryPermissions(gallery)))
  );

  subGalleryPermissions = signal(<GalleryDto['permissions']>{});
  isPicflowIOSApp = isPicflowIOSApp();

  isSubGallery = computed(() => {
    return !!this.gallery()?.parent_gallery;
  });
}
